import { storeLocal } from '../../../helpers/stores'

/**
 * С какого тарифа доступны отзывы. Тарифы считаются с нуля; пороги те же, что
 * на бэкенде в ReviewSettingsDTO::minPricingPlan — ниже порога бэкенд считает тип
 * выключенным, что бы ни стояло в настройках.
 */
export const REVIEW_PLANS = {
    order: 2,
    product: 3,
    feed: 3,
}

export const planAllows = (plan: number): boolean => !(storeLocal.get('pricing_plan') < plan)
